import { render, staticRenderFns } from "./LpuSelect.vue?vue&type=template&id=3070d86b&"
import script from "./LpuSelect.vue?vue&type=script&lang=js&"
export * from "./LpuSelect.vue?vue&type=script&lang=js&"
import style0 from "./LpuSelect.vue?vue&type=style&index=0&id=3070d86b&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3070d86b')) {
      api.createRecord('3070d86b', component.options)
    } else {
      api.reload('3070d86b', component.options)
    }
    module.hot.accept("./LpuSelect.vue?vue&type=template&id=3070d86b&", function () {
      api.rerender('3070d86b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/DoctorServicePrices/components/LpuSelect/LpuSelect.vue"
export default component.exports